export const inputClass =
  'rounded-md border bg-background px-3 py-2.5 text-base text-foreground focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary';
export const labelClass = 'grid gap-1.5 text-sm font-semibold text-muted-foreground';
